import { formatISO, startOfDay } from 'date-fns';
import * as React from 'react';
import { Form } from 'react-bootstrap';
import DatePicker from 'react-datepicker';

import { getAll } from '@/helper/apicalls';
import { FormContext } from '@/helper/context';
import { User } from '@/helper/interfaces';

import { CustomInput } from './datepicker-custom';
import { SelectorAPI } from './selector-api';

interface Properties {
  value?: string;
  valueSelect?: string;
  userId: number;
  excludedUsers?: number[];
  allowPast?: boolean;
  trackChanges?: boolean;
}

export function SelectorPta({
  value,
  valueSelect,
  trackChanges = true,
  userId,
  excludedUsers,
  allowPast = false
}: Properties) {
  const { changeTracker, setWasChanged, disabled, errors } = React.useContext(FormContext);

  const getDate = valueSelect ?? value;
  const [dateState, setDateState] = React.useState(
    getDate ? new Date(getDate) : new Date(new Date().setHours(10, 0, 0, 0))
  );
  const [excludedUsersState, setExcludedUsersState] = React.useState<number[]>(excludedUsers ?? []);

  React.useEffect(() => {
    const didChange = valueSelect ? (valueSelect == value ? false : true) : false;
    changeTracker.current = {
      ...changeTracker.current,
      date: didChange
    };
    setWasChanged(trackChanges ? Object.values(changeTracker.current).includes(true) : true);
  }, []);

  async function setDate(selectedDate: Date) {
    setDateState(selectedDate);

    // updated excluded users
    try {
      const isoDate = formatISO(startOfDay(selectedDate));
      const data = await getAll('/users/pta?date=' + isoDate);
      setExcludedUsersState(data.map((d: User) => d.id));
    } catch (error) {
      console.error('Failed to fetch excluded users:', error);
      setExcludedUsersState([]);
    }

    const didChange = selectedDate?.toISOString() == value ? false : true;
    changeTracker.current = {
      ...changeTracker.current,
      date: didChange
    };
    setWasChanged(Object.values(changeTracker.current).includes(true));
  }

  return (
    <React.Fragment>
      <Form.Control type='hidden' name='date' value={dateState?.toISOString()} />
      <Form.Group className='mt-3 col-6'>
        <span className={'d-block form-label' + (errors?.date ? ' is-invalid' : '')}>Date</span>
        <DatePicker
          selected={dateState}
          disabled={disabled}
          minDate={allowPast ? undefined : new Date()}
          onChange={(date) => setDate(date)}
          dateFormat='MMM do, yyyy'
          customInput={<CustomInput />}
          todayButton='Today'
        />
        <Form.Control.Feedback type='invalid'>{errors?.date}</Form.Control.Feedback>
      </Form.Group>
      <SelectorAPI
        name='user'
        displayName='Staff'
        size='col-12'
        fetchURL='/users/mixers_assistants'
        value={userId}
        exclude={excludedUsersState}
      />
    </React.Fragment>
  );
}
